import React from 'react'
import styled from 'styled-components'
import { Button as SutraButton } from 'sutra/components/Button'

export type ExportButtonViewProps = {
  isPreparing: boolean
  disabled?: boolean
  onClick: () => void
}

const DownloadIcon = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-bottom: 2px solid currentColor;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: -2px;
    width: 2px;
    height: 8px;
    background: currentColor;
    transform: translateX(-50%);
  }
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 4px;
    width: 6px;
    height: 6px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translateX(-50%) rotate(45deg);
  }
`

/**
 * Pure view — Yogi-staff Export entry point in the homepage toolbar.
 * No hooks/effects; renders props. Visually consistent with the
 * sibling Filters/Edit toolbar buttons.
 */
export const ExportButtonView: React.FC<ExportButtonViewProps> = ({
  isPreparing,
  disabled,
  onClick,
}) => (
  <SutraButton
    variant={isPreparing ? 'dark' : 'secondary'}
    size="sm"
    height="32px"
    disabled={disabled || isPreparing}
    onClick={onClick}
  >
    <DownloadIcon />
    {isPreparing ? 'Exporting…' : 'Export'}
  </SutraButton>
)
